let selectedCountries = []

const updateSelectedCountries = () => {
    selectedCountries = $('.product_vat_category_country_select :checked').map(function(_, v) { return $(v).val()}).get();
}

const sortOptions = (selectElement) => {
  const options = Array.from(selectElement.options);
  const sortedOptions = options.sort((a, b) => a.text.localeCompare(b.text));

  selectElement.innerHTML = '';
  sortedOptions.forEach(option => selectElement.add(option));
};

const updateCountrySelections = () => {
  updateSelectedCountries();

  if(typeof(countries) !== "object")
    return;

  let indexCountries = countries.map((country) => country[1]);

  $('.product_vat_category_country_select').each((index, el) => {
    let missingOptions = indexCountries.filter((country) => selectedCountries.indexOf(country) === -1);
    let currentOptions = [];
    let selection = el.value;

    $(el).children('option').each((index, option) => {
      if(option.value === el.value)
          return;

      if(selectedCountries.indexOf(option.value) > -1) {
        $(option).remove();
      } else {
        currentOptions.push(option.value);
      }
    })

    let addOptions = missingOptions.filter((country) => currentOptions.indexOf(country) === -1);

    addOptions.forEach((country) => {
      let index = indexCountries.indexOf(country);
      $(el).append(`<option value="${countries[index][1]}">${countries[index][0]}</option>`);
    })

    if(addOptions.length > 0)
      sortOptions(el);

    el.value = selection;
  });
}

const countrySelectHTML = function(count) {
  let html = `<select name="rates[${count}][product_vat_category_country]" id="rates_${count}_product_vat_category_country" class="form-control product_vat_category_country_select">`
  updateSelectedCountries();
  html += '<option />'
  countries.forEach((country) => {
    if(selectedCountries.indexOf(country[1]) !== -1) {
      return;
    }

    html += `<option value="${country[1]}">${country[0]}</option>`
  })
  html += '</select>'
  return html
}

const countrySelectChange = (id, count, e) => {
  const $el = $(`#${id}`);
  const countryCode = $el.find("option:selected").val();
  const $rateSelect = $(`#rates_${count}_product_vat_category_rate`);
  if (!countryCode) {
    return
  }
  $rateSelect.empty();
  $('#empty-field-error').hide();

  vatRates[countryCode].forEach( rate => {
    $rateSelect.append($('<option/>', { text: rate[0], value: rate[1] }))
  });

  updateCountrySelections();
  $rateSelect.prop('disabled', false);
}

const deleteRow = (event) => {
  let countryCode = $(event.target).closest("tr").find(".product_vat_category_country_select :checked").val()
  selectedCountries = selectedCountries.filter(country => { country !== countryCode })
  $(event.target).closest("tr").remove()
  $('#empty-field-error').hide()
  updateCountrySelections();
}

$(document).ready(function() {
  updateCountrySelections();
  $('.product_vat_category_country_select').each((index, el) => {
    let id = `rates_${index}_product_vat_category_country`
    $(`#${id}`).on('change', countrySelectChange.bind(this, id, index))
  })
  $('#add_more').on('click', function() {
    let count = $('.product_vat_category_country_select').length + 1
    let rowId = `product_vat_category_row_${count}`
    let countrySelectId = `rates_${count}_product_vat_category_country`
    $('#add_more').closest('tr').before(`<tr id="${rowId}">
    <td>${countrySelectHTML(count)}</td>
    <td><select name="rates[${count}][product_vat_category_rate]" id="rates_${count}_product_vat_category_rate" class="form-control" disabled="disabled"></select></td>
    <td><a href="#" id="${rowId}-delete" class="delete_vat_rate btn btn-outline-danger btn-sm">${deleteStr}</td></tr>`
    )
    $("body").on('change', `#${countrySelectId}`, countrySelectChange.bind(this, countrySelectId, count))
    $("body").on('click', `#${rowId}-delete`, deleteRow)
  })
  $('.delete_vat_rate').on('click', deleteRow)
  $('#submit').on('click', function(e) {
    let error
    $('.product_vat_category_country_select').each((index, el) => {
      if($(el).val() === '') {
        error = true
      }
    })
    if (error) {
      e.preventDefault()
      $('#empty-field-error').show()
      return false
    }
  })
})
